import { LearningTypes } from '@enums/LearningTypes';
import { ApiResponse } from '@interfaces/index';
import { useQuery } from '@tanstack/react-query';
import { apiUrlConfig } from './configs/apiUrlConfig';
import createApiClient from './configs/httpHandler';
import { getAllLearningByFilterCriteria } from './learningContent';

export interface LearningResourcesAccessCounts {
  videoContent: number;
  articleContent: number;
  totalContent: number;
}

// Learning API Handler
export const learningApiHandler = {
  getUserLearningResourcesAccessCounts: async (): Promise<
    ApiResponse<LearningResourcesAccessCounts>
  > =>
    createApiClient(apiUrlConfig.EXPRESS_BACKEND_V2).get(
      '/get-user-learning-resources-access-counts',
    ),

  getRecommendedIndicatorLearnings: async (
    indicatorId: number,
  ): Promise<ApiResponse<LearningContent[]>> =>
    createApiClient(apiUrlConfig.EXPRESS_BACKEND_V2).get(
      `/indicator-learnings-recommendation/${indicatorId}`,
    ),
};

export const fetchLearningResources = async (): Promise<
  ApiResponse<LearningResourcesAccessCounts>
> => learningApiHandler.getUserLearningResourcesAccessCounts();

export const fetchIndicatorLearningResources = async (
  indicatorId: number,
): Promise<ApiResponse<LearningContent[]>> =>
  learningApiHandler.getRecommendedIndicatorLearnings(indicatorId);

export const useGetAllWpPostsForCarousel = () =>
  useQuery({
    queryKey: ['wpPosts'],
    queryFn: async () => {
      const response = await getAllLearningByFilterCriteria({
        order: 'DESC',
        orderBy: 'contentCreatedAt',
        page: 1,
        perPage: 60,
        questionIds: [],
        tagIds: [],
      });

      return (
        response?.data?.map((dt) => ({
          id: dt.id,
          innerImageUrl: dt.imageUrl,
          title: dt.title,
        })) || []
      );
    },
    select: (data) => data,
  });

export interface LearningContent {
  id: number;
  title: string;
  imageUrl: string;
  clientCustomContent: boolean;
  contentCreatedAt: string; // ISO date string
  contentModifiedAt: string; // ISO date string
  learningContentTypeId: number | null;
  createdAt: string; // ISO date string
  updatedAt: string; // ISO date string
  learningContentType: LearningTypes | null; // Use a more specific type if available
}
